@if (menuItems && menuItems.length > 0) {
  <ng-container data-test="presetmMenu.menuItems">
    @if (schema) {
      <div class="items-center flex-end preset-info">
        @if (presetMessage) {
          <div class="items-center flex-start">
            <mat-icon style="padding-right: 1.2em">info</mat-icon>
            <span>{{ presetMessage }}</span>
          </div>
        } @else {
          <div class="initial-message flex-start">
            <span class="initial">{{ initialMessage }}</span>
          </div>
        }
        <!-- Begin Menu -->
        <button
          mat-icon-button
          aria-label="Button that chooses a Preset"
          matTooltip="Choose a Preset"
          matTooltipPosition="left"
          [matMenuTriggerFor]="parentMenu"
        >
          <mat-icon
            color="secondary"
            aria-hidden="false"
            aria-label="Button that chooses a Preset"
            class="filled"
          >
            bolt
          </mat-icon>
        </button>
        <mat-menu #parentMenu>
          @for (item of menuItems; track item) {
            <!-- <pre>{{item | json}}</pre> -->
            @if (isRootMenu(item.path)) {
              @for (menuExample of item.examples; track menuExample; let i = $index) {
                <button mat-menu-item (click)="applyExample(item, menuExample.data)">
                  <span class="items-center" [ngClass]="{'active': menuExample.isActive}">
                    {{menuExample.data["_comment"] || menuExample.data}}
                  </span>
                </button>
              }
            }
            @if (!isRootMenu(item.path)) {
              <button mat-menu-item [matMenuTriggerFor]="subMenu">
                {{ getLastKey(item.path) | titlecase }}
              </button>
              <mat-menu #subMenu="matMenu">
                @for (menuExample of item.examples; track menuExample) {
                  <button mat-menu-item (click)="applyExample(item, menuExample.data)">
                    <span class="items-center" [ngClass]="{'active': menuExample.isActive}">
                      {{menuExample.data["_comment"] || menuExample.data}}
                    </span>
                  </button>
                }
              </mat-menu>
            }
          }
        </mat-menu>
      </div>
    }
  </ng-container>
}
